@if (message() && !toast()) {
<div class="alert alert-info" role="alert">
  {{ message() | translate }}
</div>
}
